__turbopack_context__.v({
  "cardContainer": "Faculty-module-scss-module__fJyg5G__cardContainer",
  "desg": "Faculty-module-scss-module__fJyg5G__desg",
  "details": "Faculty-module-scss-module__fJyg5G__details",
  "image": "Faculty-module-scss-module__fJyg5G__image",
  "imageBox": "Faculty-module-scss-module__fJyg5G__imageBox",
  "laptopIcon": "Faculty-module-scss-module__fJyg5G__laptopIcon",
  "mobileIcon": "Faculty-module-scss-module__fJyg5G__mobileIcon",
  "name": "Faculty-module-scss-module__fJyg5G__name",
  "playIcon": "Faculty-module-scss-module__fJyg5G__playIcon",
  "root": "Faculty-module-scss-module__fJyg5G__root",
  "textContainer": "Faculty-module-scss-module__fJyg5G__textContainer",
  "video": "Faculty-module-scss-module__fJyg5G__video",
});
